import React, { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import ProjectListHeader from "../../Projects/MyProjects/ProjectListHeader";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { PlnMassTxt } from "../constant";
import ExportData from "../../ExportData";
import { ProjectService } from "../../../service/PegaService";
// import { UnsavedChangesDialog,useUnsavedChangesWarning } from "../../common/NavigationPrompt";
import { Button } from "react-bootstrap";
import { CustomizeView } from "../constant";
import WrapIcon from "../../../assets/images/wrap-icon.png";

const CapacityManagementSubHeader = ({
  handleMessUpPlan,
  isProjectData,
  isTaskData,
  isSearch,
  isSearchSet,
  planningData,
  selectedTask,
  selectedProject,
  activeTable,
  isFilterEnabled,
  setLoader,
  setClearAllFilter,
  onChildClick,
  // formValid,
  setShowCustomizedView,
  Headers,
  activeTabSection,
  capacityPlanWrapFreeText,
  setcapacityPlanWrapFreeText,
}) => {
  const toast = useRef(null);
  // initial state
  // const [showDialog, setShowDialog] = useState(false);
  // const { markClean } = useUnsavedChangesWarning();

  const columns = planningData?.isTask
    ? ProjectService.getAvailablePlanningColumnNames()
    : ProjectService.getAvailablePlanningProjectColumnNames();
  // const fileName = planningData?.isTask ? "Task_List" : "Project_List";
  //Export file name issue fix in Planning
  const fileName = activeTabSection === "ProjectList" ? "Project_List" : "Task_List";
  const onSearchClick = () => {
    isSearchSet(!isSearch);
  };

  const handleMeesUpdateClick = () => {
    handleMessUpPlan();
    // if(formValid){
    //   setShowDialog(true);
    // }else{
    // handleMeesUpdate();
    // }
  };

  // const handleMeesUpdate = () => {
  //   handleMessUpPlan();
  // };

  // const confirmNavigation = () => {
  //   setShowDialog(false);
  //   handleMeesUpdate();
  // };

  // const cancelNavigation = () => {
  //   setShowDialog(false);
  // };

  const onClickClearFilter = () => {
    isSearchSet(false);
    setClearAllFilter(true);
    localStorage.removeItem("sortedColumnPlanning");
    localStorage.removeItem("_selectedFieldsRefCurrentPlanning");
  };

  return (
    <div className="projectSetupParent project-plan-wrapper newdiv subHeaderWrapper">
      <Toast ref={toast} />
      <div className="breadCrumbParent">
        <div className="row">
          <div className="col acp-header">
            <ProjectListHeader
              clearFilters={onClickClearFilter}
              clearFilter={onClickClearFilter}
              onSearchClick={onSearchClick}
              isFilterEnabled={isFilterEnabled}
              headers={Headers}
              filterFLag={false}
              CustomizeViewFlag={true}
              ResetToDefaultFlag={true}
              onChildClick={onChildClick}
            />

            <div className="excelIcon">
              {planningData?.planningData?.length ? (
                <ExportData
                  allData={planningData?.planningData}
                  selectedRows={
                    selectedTask?.length > 0 || selectedProject?.length > 0
                      ? activeTable === "TaskList"
                        ? selectedTask
                        : selectedProject
                      : activeTable === "TaskList"
                        ? isTaskData
                        : isProjectData
                  }
                  filename={fileName}
                  headers={Headers}
                />
              ) : null}
            </div>
            <img
                  src={WrapIcon}
                  alt={capacityPlanWrapFreeText ? "Unwrap Free Text" : "Wrap Free Text"}
                  title={capacityPlanWrapFreeText ? "Unwrap Free Text Columns" : "Wrap Free Text Columns"}
                  onClick={() => setcapacityPlanWrapFreeText((prev) => !prev)}
                  style={{
                    cursor: "pointer",
                    margin: " 10px 10px",
                    width: "20px",
                    height: "20px",
                    filter: setcapacityPlanWrapFreeText ? "none" : "grayscale(100%)"
                  }}
              />
            {
              activeTabSection !== "ProjectList" && (
                <div>
                  <Button
                    variant="secondary"
                    className="button-layout"
                    onClick={() => setShowCustomizedView(true)}
                  >
                    {CustomizeView}
                  </Button>
                </div>
              )
            }

            <div className="action-buttons">
              <DropdownButton
                title="Action"
                disabled={!selectedTask.length && !selectedProject.length}
                className="dropdown-button-custom"
              // id={!actionFlag.length ? "tasksInActive" : "tasksActive"}
              >
                <React.Fragment>
                  <Dropdown.Item className="text-massUpdate" onClick={handleMeesUpdateClick}>{PlnMassTxt}</Dropdown.Item>
                </React.Fragment>
              </DropdownButton>
            </div>
          </div>
        </div>
      </div>
      {/* UnsavedChangesDialog popup*/}
      {/* <UnsavedChangesDialog
          visible={showDialog}
          onCancel={cancelNavigation}
          onConfirm={confirmNavigation}
        /> */}
    </div>
  );
};
export default CapacityManagementSubHeader;
